import { Position, StateObj } from 'src/types'
import { bankLace } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/bank'
import { indexTop, indexTopOver } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/connectIndexToWeb'
import { thumbTop, thumbTopOver, thumbWrapBack } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/connectThumbToWeb'
import { connectIndexToMiddle, connectMiddleToRing, connectRingToLittle } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/fingerTop'
import { knotDownward, knotUpward } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/knotSingle'
import { littleUpper } from 'src/features/dxm/drawer/rightThrow/glove/front/lace/littleUpper'

export const lace = (ctx: CanvasRenderingContext2D, color: string, materialPack: StateObj, position: Position): void => {
  // 土手レース
  bankLace(ctx, color, materialPack, position)
  thumbWrapBack(ctx, color, -215, 20, -30) // 先端側の折り返し
  thumbWrapBack(ctx, color, 0, 0) // 根元側の折り返し
  thumbWrapBack(ctx, color, -50, 80, -10) // 根元側の折り返しの下
  thumbWrapBack(ctx, color, -110, 165, -20) // 根元側の折り返しの下の下
  thumbTopOver(ctx, color)
  thumbTop(ctx, color)
  indexTopOver(ctx, color) // 人差し指先端＿ウェブ繋ぎこみ奥
  indexTop(ctx, color) // 人差し指先端＿ウェブ繋ぎこみ手前
  knotUpward(ctx, color)
  knotDownward(ctx, color)
  connectIndexToMiddle(ctx, color) // 指先端の繋ぎ
  connectMiddleToRing(ctx, color) // 指先端の繋ぎ
  connectRingToLittle(ctx, color) // 指先端の繋ぎ
  littleUpper(ctx, color) // 薬指と小指の溝直下の1つの革紐
}
